import React from "react";

// Fire-equipment icons lucide-react doesn't ship (it has no hydrant, pump or valve). Drawn on the
// same 24×24 grid with a 2px round stroke in currentColor, so they sit alongside lucide icons and
// take the same `className` sizing/color utilities.

function Svg({ className, strokeWidth = 2, children, title }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
    >
      {title && <title>{title}</title>}
      {children}
    </svg>
  );
}

export function HydrantIcon(props) {
  return (
    <Svg {...props}>
      <path d="M12 2v2" />
      <path d="M8 8a4 4 0 0 1 8 0" />
      <path d="M7 8h10" />
      <path d="M8 8v11" />
      <path d="M16 8v11" />
      <path d="M8 12H5v3h3" />
      <path d="M16 12h3v3h-3" />
      <circle cx="12" cy="13.5" r="1.5" />
      <rect x="6" y="19" width="12" height="3" rx="1" />
    </Svg>
  );
}

// Pendant sprinkler head: supply pipe, frame arms, glass bulb, deflector and spray.
export function SprinklerIcon(props) {
  return (
    <Svg {...props}>
      <path d="M12 2v3" />
      <path d="M9 5h6" />
      <path d="M10 5l-1 6" />
      <path d="M14 5l1 6" />
      <circle cx="12" cy="8.5" r="1" />
      <path d="M6 11h12" />
      <path d="M8 14l-2 3" />
      <path d="M12 14v4" />
      <path d="M16 14l2 3" />
      <path d="M5 20l-1 1.5" />
      <path d="M12 20.5v1" />
      <path d="M19 20l1 1.5" />
    </Svg>
  );
}

export function PumpIcon(props) {
  return (
    <Svg {...props}>
      <circle cx="9" cy="12" r="5" />
      <circle cx="9" cy="12" r="1.5" />
      <path d="M10 7V3h6" />
      <path d="M4 12H2" />
      <path d="M14 12h2" />
      <rect x="16" y="9.5" width="6" height="5" rx="1" />
      <path d="M5 20h14" />
      <path d="M7 17l-1 3" />
      <path d="M11 17l1 3" />
    </Svg>
  );
}

// Fire/smoke damper: a duct section with angled blades.
export function DamperIcon(props) {
  return (
    <Svg {...props}>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M7 16l3-8" />
      <path d="M11 16l3-8" />
      <path d="M15 16l3-8" />
      <path d="M1 12h2" />
      <path d="M21 12h2" />
    </Svg>
  );
}

export function ValveIcon(props) {
  return (
    <Svg {...props}>
      <path d="M3 10v8l9-4-9-4z" />
      <path d="M21 10v8l-9-4 9-4z" />
      <path d="M12 14V6" />
      <path d="M8 5h8" />
      <path d="M2 14h1" />
      <path d="M21 14h1" />
    </Svg>
  );
}
